import React, { Component } from 'react'
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha"
import { Redirect } from "react-router-dom"

import "bootstrap/dist/css/bootstrap.min.css"

const recaptchaRef = React.createRef()
class VenueSignUp extends Component {
  constructor() {
    super()
    this.state = {
      name: "",
      emails: [],
      url: "",
      phone: "",
      password: "",
      confirmPassword: "",
      human: false,
      complete: false
    }
    this.changeName = this.changeName.bind(this)
    this.changeEmail = this.changeEmail.bind(this)
    this.changeUrl = this.changeUrl.bind(this)
    this.changePhone = this.changePhone.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changeConfirmPassword = this.changeConfirmPassword.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }
  changeName(event) {
    this.setState({
      name: event.target.value
    })
  }
  changeEmail(event) {
    this.setState({
      email: event.target.value
    })
  }
  changeUrl(event) {
    this.setState({
      url: event.target.value
    })
  }
  changePhone(event) {
    this.setState({
      phone: event.target.value
    })
  }
  changePassword(event) {
    this.setState({
      password: event.target.value
    })
  }
  changeConfirmPassword(event) {
    this.setState({
      confirmPassword: event.target.value
    })
  }

  onSubmit(event) {
    event.preventDefault()
    const { password, confirmPassword } = this.state;
    if (password !== confirmPassword) {
      alert("Password don't match");
    }
    else
      if (this.state.human === true) {
        const registered = {
          name: this.state.name,
          email: this.state.email,
          url: this.state.url,
          password: this.state.password
        }
        axios.post('http://localhost:4000/app/sign-up', registered)
          .then((response) => {
            console.log("RESPONSE", response)
            if (response.data.value === 0) {
              this.setState({ complete: true })
              alert("Thank you for signing up")
            }
            else if (response.data.value === 1) {
              alert("That email is already registered.")
            }
            else {
              alert("Something went wrong - please send me an email at logan@seatstir.com")
            }
          })
      }
      else {
        alert("Please prove you're not a robot")
      }
  }
  onChange(value) {
    const recaptchaValue = recaptchaRef.current.getValue();
    if (value === recaptchaValue) {
      this.setState({
        human: true
      })
    }
  }

  render() {
    if (this.state.complete) {
      return <Redirect to={{ pathname: "/" }} />
    }
    return (
      <div>
        <div id="callMe" className="form-1">
          <div className="container">
            <div className="row" id="signUpTestRow">
              <div className="col-lg-6" id="signUpTestRowA">
                <div className="text-container getInTouchContainer">
                  <div className="section-title">SIGN UP TODAY</div>
                  <h2 className="white">Are you not entertained?!</h2>
                  <p className="white">We list shows and events which our members get to attend free. A typical member is
                  likely to find a new favorite venue participating along the way, along with plenty of places they
                  didn't know about or have yet to visit. A SeatStir membership is your invitation to explore your area!</p>
                  <ul className="list-unstyled li-space-lg white">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">The Netflix of live entertainment</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Always have something fun to do</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6" id="memberSignUpForm">
                <form
                  id="callMeForm"
                  data-toggle="validator"
                  data-focus="false"
                  onSubmit={this.onSubmit}
                >
                  <div className="form-group">
                    <input type="text" className="form-control-input" id="lname" name="lname" required onChange={this.changeName} value={this.state.Name} placeholder="Name" />
                    {/* <label className="label-control" htmlFor="lname">Full Name</label> */}
                  </div>
                  <div className="form-group">
                    <input type="text" className="form-control-input" id="lurl" name="lurl" required onChange={this.changeUrl} value={this.state.Url} placeholder="Venue website" />
                    {/* <label className="label-control" htmlFor="lname">Full Name</label> */}
                  </div>
                  <div className="form-group">
                    <input type="text" className="form-control-input" id="lphone" name="lphone" required onChange={this.changePhone} value={this.state.Phone} placeholder="Venue phone number" />
                    {/* <label className="label-control" htmlFor="lname">Full Name</label> */}
                  </div>
                  <div className="form-group">
                    <input type="email" className="form-control-input" id="lemail" name="lemail" required onChange={this.changeEmail} value={this.state.email} placeholder="Email" />
                    {/* <label className="label-control" htmlFor="lemail">Email</label> */}
                  </div>
                  <div className="form-group">
                    <input type="password" className="form-control-input" id="lpassword" name="lpassword" required onChange={this.changePassword} value={this.state.password} placeholder="Password" />
                    {/* <label className="label-control" htmlFor="lemail" >Password</label> */}
                  </div>
                  <div className="form-group">
                    <input type="password" className="form-control-input" id="lconfirmPassword" name="lconfirmPassword" required onChange={this.changeConfirmPassword} value={this.state.confirmPassword} placeholder="Confirm Password" />
                    {/* <label className="label-control" htmlFor="lemail" >Password</label> */}
                  </div>
                  <div className="form-group checkbox white">
                    <input type="checkbox" id="lterms" value="Agreed-to-Terms" name="lterms" required />I agree
                                with Seatstir's stated <a className="white" href="privacy-policy.html">Privacy Policy</a> and <a
                      className="white" href="terms-conditions.html">Terms & Conditions</a>
                  </div>
                  <div className="form-group" id="memberSubmitContainer">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={this.onChange}
                      theme="dark"
                    />
                    <input type="submit" className="form-control-submit-button" value="Submit" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default VenueSignUp